import { wafflesKeyColumnName } from "@app/shared/waffles";
import { OfficeHoursViewModel } from "@app/projects/results/accuracy/officeHourViewModel"
import InspectionProfileTableData from "./inspectionProfileTableData";
import generateDefaultProviderPanelRow from "./defaultProviderPanelRow";
import { getSupplementalDataDecorationWithoutSource, valueOrDashes } from "./utils";
import { formatUnconvertedDateCustom } from "@app/shared/formatDateTime";
import { OfficeHoursTimeSpan } from "@app/projects/results/accuracy/officeHoursTimeSpan";

/* oxlint-disable sort-keys */
const populateOfficeHours = (model: OfficeHoursViewModel[], tableData: InspectionProfileTableData[]) : void => {

  if (model?.length) {
    model.forEach((officeHour: OfficeHoursViewModel, index: number) => {
      tableData.push(
        {
          [wafflesKeyColumnName]: `locationOfficeHours-${index}`,
          title: index === 0 ? "Location Office Hours" : "",
          source: (
            officeHour.sourceHours && officeHour.sourceHours.day ?
              <div key={index}>
                <div>
                  {valueOrDashes(officeHour.sourceHours && officeHour.sourceHours.day ? officeHour.sourceHours.day : "")} : {officeHour.sourceHours ? officeHour.sourceHours.hours.map((hour, i: number) => buildTableCellContent(hour, i)) : ""}
                </div>
              </div> :
              ""
          ),
          result: (
            officeHour.inspectionSupplement && officeHour.inspectionSupplement.value ?
              <div key={index}>
                {getSupplementalDataDecorationWithoutSource(
                  (<span>{valueOrDashes(officeHour.inspectionSupplement.value.day)}: {officeHour.inspectionSupplement.value.hours.map((hour, i: number) => buildTableCellContent(hour, i))}</span>),
                  officeHour.inspectionSupplement.supplementalType
                )}
              </div> :
              <div></div>
          ),
          reference: (<>
            {valueOrDashes(officeHour.inspectionSupplement && officeHour.inspectionSupplement.sourceName ? officeHour.inspectionSupplement.sourceName : "")}
            &nbsp;
            {(officeHour.inspectionSupplement && officeHour.inspectionSupplement.sourceName) ?
              valueOrDashes(officeHour.inspectionSupplement && officeHour.inspectionSupplement.sourceDate ? `(${formatUnconvertedDateCustom(officeHour.inspectionSupplement.sourceDate, "L")})` : "") :
              null
            }
          </>),
          attestationMethod: <>{"---"}</>,
          attesterInfo: <>{"---"}</>
        });
    });
  } else {
    tableData.push(
      generateDefaultProviderPanelRow("locationOfficeHours", "Location Office Hours", null, null)
    );
  }  
};

function buildTableCellContent(hour: OfficeHoursTimeSpan, i: number) {
  if (hour.startTime === "55:55" || hour.endTime === "55:55")
    return (<span key={i}>{"By Appointment Only"}</span>);

  if (hour.startTime === "99:99" || hour.endTime === "99:99")
    return (<span key={i}>{"Closed"}</span>);

  return (<span key={i}>{valueOrDashes(convertFrom24To12Format(hour.startTime))} - {valueOrDashes(convertFrom24To12Format(hour.endTime))}</span>);
}

function convertFrom24To12Format(time24: string) {
  if (time24 === "99:99" || time24 === "55:55") return time24;
  const [sHours, minutes] = time24.match(/([0-9]{1,2}):([0-9]{2})/).slice(1);
  const period = +sHours < 12 ? "AM" : "PM";
  const hours = +sHours % 12 || 12;

  return `${hours}:${minutes} ${period}`;
}

export default populateOfficeHours;